import React from 'react'
import Select, { Option } from 'rc-select'
import PropTypes from 'prop-types'
import './customSelect.module.scss'

const CustomSelect = (props) => {
  const {
    showSearch,
    placeholder,
    options,
    onChange,
    onSearch,
    optionFilterProp,
    filterOption,
    loading,
    value
  } = props

  return (
    <Select
      loading={loading}
      placeholder={placeholder}
      showSearch={showSearch}
      onSelect={onChange}
      filterOption={filterOption}
      optionFilterProp={optionFilterProp}
      notFoundContent={false}
      onSearch={onSearch}
      value={value}
    >
      {options.map((option) => (
        <Option key={option.value} value={option.value}>
          {option.name}
        </Option>
      ))}
    </Select>
  )
}

CustomSelect.defaultProps = {
  options: [],
  showSearch: false,
  placeholder: 'Selecione',
  onSearch: null,
  loading: false,
  value: null,
  optionFilterProp: null,
  filterOption: false
}

CustomSelect.propTypes = {
  showSearch: PropTypes.bool,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string
    })
  ),
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  loading: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  optionFilterProp: PropTypes.string,
  filterOption: PropTypes.bool
}

export default CustomSelect
